import './filter.css';
import _ from 'lodash';
import { useState, useEffect, useRef } from 'react';
import postal from 'postal';

import styled from 'styled-components';
import Number from '../Number';
import Float from '../Float';
import TextBox from '../TextBox';
import LabeledCheckBox from '../LabeledCheckBox';
import IfmsDate from '../Date';
import InputControlRow from '../layout/InputControlRow';
import PrimaryButton from '../PrimaryButton';
import IfmsModal from '../IfmsModal';

import CheckBox from '../CheckBox';
import CheckBoxIcon from '../CheckBoxIcon';
import { dateTextToIso, formatDate } from '../../dateUtils';
import Select from '../Select';
import SecondaryButton from '../SecondaryButton';
import RadioButton from '../RadioButton';
import OrchidTracking_Y from '../../img/orchid_tracking-yellow.svg';
import OrchidTracking_R from '../../img/orchid_tracking-red.svg';
import OrchidTracking_B from '../../img/orchid_tracking-blue.svg';
import OrchidTracking_G from '../../img/orchid_tracking-green.svg';
import OrchidTracking_T from '../../img/manifest_tracking.svg';
import { initialSearch } from '../../filtering';

export const nullSearchEnableColumns = ['status', 'recognized', 'moveType', 'void', 'draft', 'isVoid', 'jobType', 'trStatus', 'trStatus2','loadStatus','cbpHold'];

const FilterContent = styled.div`
  margin: 10px;
  margin-top: 0px;
  font-family: Inter;

    .header-strong {
      margin-top: 5px;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      color: #252A37;
      line-height: 28px;
    }

    .header {
      margin-top: 3px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #252A37;
      line-height: 28px;
    }
`;

/*
const Pager = styled.div`
  margin-left: 5px;
  width: 135px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  div {
    margin-left: 2px;
    margin-right: 2px;
  }
`;
*/

const IncludeSearchProperties = [
  'general1',
  'general2',
  'general3',
  'date',
  'date1',
  'date2',
  'number',
  'number1',
  'number2',
  'location1',
  'location2',
  'location3',
  'generalText1',
  'generalText2',
  'generalText3',
  'generalNullOrEmpty',
  'dateFrom',
  'dateTo',
  'dateFrom1',
  'dateTo1',
  'dateFrom2',
  'dateTo2',
  'dateNullOrEmpty',
  'location1Text',
  'location2Text',
  'location3Text',
  'numberFrom',
  'numberTo',
  'numberFrom1',
  'numberTo1',
  'numberFrom2',
  'numberTo2',
  'numberNullOrEmpty',
  'extras',
];

function searchInFilterOrderComparer(l:any, r:any) {
  if (!l || !r) {
    return false;
  }

  const result = _.isEqual(_.pick(l, IncludeSearchProperties), _.pick(r, IncludeSearchProperties));
  return result;
}

// Tries to get the data from DOM in order to have to change dependencies on all screens to add additional title param
function extractScreenTitleBar() {
  const titleNodes = document.querySelectorAll('.ifms-screen-title-bar > h2');
  if (titleNodes && titleNodes.length) {
    const n = titleNodes[0] as HTMLElement;
    return n.innerText;
  }
  return '';

}

function StatusFilter({
  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const items = [
    { label: '', value: '' },
    { label: 'OP Close', value: 'OC' },
    { label: 'Period Close', value: 'PC' },
  ]

  return (
    <Select
      name='ifms-filter-status-select'
      selectId='ifms-filter-status'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}   
      applySearchWithEnter={onEnter}
    />
  );
}

function StatusFilterNotUseFileLocked({
  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const items = [
    { label: '', value: '' },
    { label: 'Period Close', value: 'PC' },
  ]

  return (
    <Select
      name='ifms-filter-status-select'
      selectId='ifms-filter-status'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}
      applySearchWithEnter={onEnter}
    />
  );
}

function LoadStatusFilter({
  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const items = [
    { value: '', label: '' },
    { value: 'Dispatched', label: 'Dispatched' },
    { value: 'In-Transit', label: 'In-Transit' },
    { value: 'Delivered', label: 'Delivered' },
    { value: 'Completed', label: 'Completed' },
  ]

  return (
    <Select
      name='ifms-filter-loadStatus-select'
      selectId='ifms-filter-loadStatus'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}
      applySearchWithEnter={onEnter}
    />
  );
}


function RQFilterRenderer({  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
 }) {
  return (
    <>
    <Select
      name='ifms-filter-rqcol-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'All', label: 'All Container Tracking' },
        { value: 'realTracker', label: 'Real-Time Tracker', icon: OrchidTracking_T, iconSize: '16' },
        { value: 'Q', label: 'Start to Request', icon: OrchidTracking_Y, iconSize: '16' },
        { value: 'created', label: 'Under Movement', icon: OrchidTracking_G, iconSize: '16' },
        { value: 'tracking_stopped', label: 'End of Tracking', icon: OrchidTracking_B, iconSize: '16' },
        { value: 'failed', label: 'Invalid or Error', icon: OrchidTracking_R, iconSize: '16' },
      ]}
      applySearchWithEnter={onEnter}
    />
    </>
  );
}


function CbpHoldFilterRenderer({  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
 }) {
  return (
    <>
    <Select
      name='ifms-filter-cbpHold-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: '', label: '' },
        { value: 'CBP Hold', label: 'CBP Hold'},
        { value: 'Hold Removed', label: 'Hold Removed'}
      ]}
      applySearchWithEnter={onEnter}
    />
    </>
  );
}

function GeneralFilter({disabled, value, onChange, accessor, customRenderers, onEnter}:any) {

  if (accessor && customRenderers) {
    const customRenderer = customRenderers.find((x:any) => x.accessor === accessor);
    if (customRenderer) {
      return customRenderer.renderer({disabled, value, onChange, onEnter});
    }
  }

  return (
    <TextBox
      name='ifms-filter-general-searchTextBox'
      textId="ifms-filter-general"
      disabled={disabled}
      value={value}
      onChange={e => onChange(e.target.value)}
      onEnter={onEnter}
    />
  );
}

function FilterSummary({ filterOrder, search }: any) {
  if (!filterOrder || filterOrder.length <= 0) {
    return <div>&nbsp;</div>;
  }

  function renderDateRangeValue(x: any) {
    const parts = x.value ? x.value.split('~') : [];
    const from = parts.length > 0 ? formatDate(parts[0].trim()) : '';
    const to = parts.length > 1 ? formatDate(parts[1].trim()) : '';

    return <span style={{fontSize: '12px'}}>{formatDate(from)} ~ {formatDate(to)}</span>;
  }

  function renderValue(x: any) {
    if (x.type === 'bool') {
      return <CheckBoxIcon value={x.value} />;
    }
    if (x.type === 'date') {
      return renderDateRangeValue(x);
    }
    return (
      <>
        {x.value}
      </>
    );
  }

  function getSearchHistoryValue(recordCount: number) {
    let result = '';
    if (recordCount !== undefined && recordCount !== null)
      //result = "displayRecordNum / FoundRecordNum"
      result = recordCount > search.pageSize ? `${search.pageSize}/${recordCount} Records found` : `${recordCount}/${recordCount} Records found`
    return result;
  }
    
  const tempReverseArray = [...filterOrder].reverse();

  return (
    <div>
      {tempReverseArray.slice(-6).map((x:any, i:number) => (
        <div key={i} style={{marginLeft:'10px'}}>
          <div id={`search-history-line-${i}`} style={{float: 'left', width: 'calc(100% - 220px)'}}>
            <span style={{ paddingRight: '25px'}}>Search {tempReverseArray.length <= 6 ? i + 1 : tempReverseArray.length - (5 - i)}</span> 
            {x.label}: {renderValue(x)}
          </div>
          <div id={`search-history-Record-${i}`} style={{float: 'left', width: '220px', paddingLeft:'60px'}}>
            {getSearchHistoryValue(x.count)}
          </div>
          <div style={{clear: 'both'}}></div>
        </div>
      ))}
    </div>
  );
}

function FilterEntry({
  filterId,
  filterLabel,
  entryType,
  value,
  onChange,
  nullOrEmpty,
  setNullOrEmpty,
  customRenderers,
  applySearch,
  floatOverride,
  decimals,
  noNullOrEmptySearches,
}: any) {

  // Status column has special rendering and to avoid duplication it is handled here. If no customRenderers are available,
  // render this as a default
  if (filterId === 'status' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (

      <div style={{ width: '350px' }}>
        <InputControlRow label="Status" bold>
          {customRenderers.some((x: any) => x.accessor === 'statusNotUseFileLocked') ?
            <StatusFilterNotUseFileLocked
              value={value}
              onChange={value => {
                onChange(value);
                setNullOrEmpty(value);
              }}
              customRenderers={customRenderers}
              accessor={filterId}
              onEnter={applySearch}
            />
            :
            <StatusFilter
              value={value}
              onChange={value => {
                onChange(value);
                setNullOrEmpty(value);
              }}
              customRenderers={customRenderers}
              accessor={filterId}
              onEnter={applySearch}
            />
          }
        </InputControlRow>

      </div>
    );
  }

  if (filterId === 'loadStatus' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (
      <div style={{ width: '350px' }}>
        <InputControlRow label="Load Status" bold>
          <LoadStatusFilter
            value={value}
            onChange={value => {
              onChange(value);
              setNullOrEmpty(value);
            }}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        </InputControlRow>
      </div>
    );
  }

  if (filterId === 'trStatus' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (
      <div style={{ width: '350px' }}>
        <InputControlRow label="Orchid Tracking" bold>
          <RQFilterRenderer
            value={value}
            onChange={value => {
              onChange(value);
              setNullOrEmpty(value);
            }}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        </InputControlRow>
      </div>
    );
  }

  if (filterId === 'cbpHold' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (
      <div style={{ width: '350px' }}>
        <InputControlRow label="Remarks" bold>
          <CbpHoldFilterRenderer
            value={value}
            onChange={value => {
              onChange(value);
              setNullOrEmpty(value);
            }}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        </InputControlRow>
      </div>
    );
  }


  if (!entryType) {
    return (
      <div>&nbsp;</div>
    );
  }

  const checkbox = noNullOrEmptySearches.some((x: any) => x.accessor === filterId) ? null : 
    <div style={{ width:'200px', marginTop: '10px', marginLeft: '10px' }}>
    <LabeledCheckBox
      reverse
      labelSize="180px"
      label="Search by Null or Empty"
      name='search-search-by-null-or-empty'
      value={nullOrEmpty}
      onChange={nullOrEmpty => {
        if (nullOrEmpty) {
          if (entryType === 'date' || entryType === 'number') {
            value.to = null;
            value.from = null;
            onChange(value);
          }
          else
            onChange(null);
        }
        setNullOrEmpty(nullOrEmpty);
      }
      }
    />
      {/* <LeftRightSplit
        leftSize="100px"
        rightSize="calc(100% - 100px)"
        left={
          <div style={{ marginLeft: '15px', position: 'relative', top: '-2px' }}>
            <CheckBox value={nullOrEmpty} onChange={nullOrEmpty => {
              if (nullOrEmpty) {
                if (entryType === 'date' || entryType === 'number') {
                  value.to = null;
                  value.from = null;
                  onChange(value);
                }
                else
                  onChange(null);
              }
              setNullOrEmpty(nullOrEmpty);
            }
            } />
          </div>
        }
        right={
          <>Search by Null or Empty</>
        }
      /> */}
    </div>;

  if (entryType === 'general') {
    return (
      <div style={{ width: '350px' }}>
        {/* <InputControlRow label={filterLabel} bold> */}
          <GeneralFilter
            disabled={nullOrEmpty}
            value={value}
            onChange={onChange}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'date') {
    return (
      <div style={{ width: '350px', height: '80px' }}>
        {/* <InputControlRow label={filterLabel} bold> */}
        <div style={{ display: 'flex' }}>
          <div style={{ float: 'left', width: '90px' }}>
            <IfmsDate
            name='ifms-filter-search-datefrom'
              dateId="ifms-filter-datefrom"
              value={value?.from}
              disabled={nullOrEmpty}
              onChange={from => onChange({ from, to: from })}
              onEnter={applySearch}
              // onTabNext={() => {
              //   const focusElement = document.getElementById('ifms-filter-dateto') as HTMLInputElement;
              //   if (focusElement) {
              //     focusElement.focus();
              //     focusElement.select();
              //     return true;
              //   }
              //   return false;
              // }}
              noRangeCheck
            />
          </div>
          <div style={{ float: 'left', marginLeft: '20px' }}>
            <label style={{ fontSize: '10px', paddingTop: '8px' }}>~</label>
          </div>
          <div style={{ float: 'left', width: '90px', marginLeft: '20px' }}>
            <IfmsDate
             name='ifms-filter-search-dateto'
              dateId="ifms-filter-dateto"
              disabled={nullOrEmpty}
              value={value?.to}
              onChange={to => onChange({ from: value?.from, to })}
              onEnter={applySearch}
              noRangeCheck
            />
          </div>
        </div>
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'number') {
    const customRenderer = customRenderers.find((x:any) => x.accessor === filterId);
    if (filterId && customRenderer) {
      return customRenderer.renderer({nullOrEmpty, value, onChange});
    }

    return (
      <div style={{ width: '350px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ float: 'left', width: '90px' }}>
            <Float
              floatId="ifms-filter-number1"
              disabled={nullOrEmpty}
              value={value?.from}
              onChange={from => onChange({ from, to: from })}
              onEnter={applySearch}
              decimals={floatOverride ? 0 : decimals}
              // onTabNext={() => {
              //   const focusElement = document.getElementById('ifms-filter-number2') as HTMLInputElement;
              //   if (focusElement) {
              //     focusElement.focus();
              //     focusElement.select();
              //     return true;
              //   }
              //   return false;
              // }}
            />
          </div>
          <div style={{ float: 'left', marginLeft: '5px' }}>
            <label style={{ fontSize: '10px', paddingTop: '8px' }}>~</label>
          </div>
          <div style={{ float: 'left', width: '90px', marginLeft: '5px' }}>
            <Float
              floatId="ifms-filter-number2"
              disabled={nullOrEmpty}
              value={value?.to}
              onChange={to => onChange({ from: value?.from, to })}
              onEnter={applySearch}
              decimals={floatOverride ? 0 : decimals}
            />
          </div>
        </div>
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'location') {
    return (
      <div>
        {/* <InputControlRow label={filterLabel} bold> */}
          <TextBox textId="ifms-filter-location" disabled={nullOrEmpty} value={value} onChange={e => onChange(e.target.value)} onEnter={applySearch} />
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'bool') {
    if (filterId && customRenderers) {
      const customRenderer = customRenderers.find((x:any) => x.accessor === filterId);
      if (customRenderer?.renderer) {
        return (
          // <InputControlRow label={filterLabel} bold>
          <div>
            {customRenderer.renderer({ nullOrEmpty, value, onChange })}
          </div>
          // </InputControlRow>
        );
      }
    }
    
    return (
      <div>
        {/* <InputControlRow label={filterLabel} bold> */}
        <div>
          <CheckBox name='ifms-filter-bool-search-check' focusId="ifms-filter-bool" label='Search for Checked Box' value={value} onChange={onChange} />
        </div>
        {/* </InputControlRow> */}
      </div>
    );
  }

  return (
    <div>&nbsp;</div>
  );
}

function getFilterLabel(columnAccessor:any, entryType:any, other:any) {
  const generalFilters = other.generalFilters;
  const dateFilters = other.dateFilters;
  const numberFilters = other.numberFilters;
  const boolFilters = other.boolFilters;

  if (entryType === 'general') {
    return generalFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'date') {
    return dateFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'number') {
    return numberFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'bool') {
    return boolFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  }  

  return '';
}

function getPresetType(filterColumnPreset:any, other:any) {
  const generalFilters = other.generalFilters;
  const dateFilters = other.dateFilters;
  const numberFilters = other.numberFilters;
  const boolFilters = other.boolFilters;

  if (filterColumnPreset) {
    if (dateFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'date';
    } else if (numberFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'number';
    } else if (generalFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'general';
    } else if (boolFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'bool';
    }
  }
  return null;
}

function getPresetEmptySlot(search: any, entryType: any, multipleSearch: boolean) {
  const extraCount = search && search.extras ? search.extras.length : 0;
  if (!multipleSearch) {
    if (entryType === 'general' || entryType === 'bool')
      return 'general1';
    else if (entryType === 'date')
      return 'date';
    else if (entryType === 'location')
      return 'location1';
    else if (entryType === 'number')
      return 'number';
  }
  if (entryType === 'general' || entryType === 'bool') {
    if (!search.general1) {
      return 'general1';
    }
    if (!search.general2) {
      return 'general2';
    }
    if (!search.general3) {
      return 'general3';
    }
    return `extra-${extraCount}-general`;
  } else if (entryType === 'date') {
    if (!search.date) {
      return 'date';
    }
    if (!search.date1) {
      return 'date1';
    }
    if (!search.date2) {
      return 'date2';
    }
    return `extra-${extraCount}-date`;
  } else if (entryType === 'location') {
    if (!search.location1) {
      return 'location1';
    }
    if (!search.location2) {
      return 'location2';
    }
    if (!search.location3) {
      return 'location3';
    }
    return `extra-${extraCount}-general`;
  } else if (entryType === 'number') {
    if (!search.number) {
      return 'number';
    }
    if (!search.number1) {
      return 'number1';
    }
    if (!search.number2) {
      return 'number2';
    }
    return `extra-${extraCount}-number`;
  }
  return null;
}

function mapPresetValueToSearch(columnId:any, value:any, search:any, presetSlot:any) {
  if (!presetSlot) {
    return;
  }

  if (presetSlot.startsWith('extra')) {
    const extraParts = presetSlot.split('-');
    const extraIndex = parseInt(extraParts[1]);
    const extraSlot = extraParts[2];
    
    let tempSearchExtras = search.extras ? [...search.extras] : [];
    
    const extraCount = tempSearchExtras.length;
    
    if (tempSearchExtras.length === 0 || (extraIndex >= (extraCount - 1) && tempSearchExtras[extraIndex]?.extraSlot !== columnId)) {
      tempSearchExtras[extraIndex] = { extraSlot: columnId };
    }
    
    switch (extraSlot) {
      case 'general':
        tempSearchExtras[extraIndex] = {
          ...tempSearchExtras[extraIndex],
          generalText: value
        };
        break;
      case 'date':
        tempSearchExtras[extraIndex] = {
          ...tempSearchExtras[extraIndex],
          dateFrom: value?.from,
          dateTo: value?.to
        };
        break;
      case 'number':
        tempSearchExtras[extraIndex] = {
          ...tempSearchExtras[extraIndex],
          numberFrom: value?.from,
          numberTo: value?.to
        };
        break;
      default:
        break;
    }
    search.extras = tempSearchExtras;
  } else {
    search[presetSlot] = columnId;
  
    switch (presetSlot) {
      case 'general1':
        search.generalText1 = value;
        break;
      case 'general2':
        search.generalText2 = value;
        break;
      case 'general3':
        search.generalText3 = value;
        break;
      case 'date':
        search.dateFrom = value?.from;
        search.dateTo = value?.to;
        break;
      case 'date1':
        search.dateFrom1 = value?.from;
        search.dateTo1 = value?.to;
        break;
      case 'date2':
        search.dateFrom2 = value?.from;
        search.dateTo2 = value?.to;
        break;
      case 'location1':
        search.location1Text = value;
        break;
      case 'location2':
        search.location2Text = value;
        break;
      case 'location3':
        search.location3Text = value;
        break;
      case 'number':
        search.numberFrom = value?.from;
        search.numberTo = value?.to;
        break;
      case 'number1':
        search.numberFrom1 = value?.from;
        search.numberTo1 = value?.to;
        break;
      case 'number2':
        search.numberFrom2 = value?.from;
        search.numberTo2 = value?.to;
        break;
      default:
        break;
    }
  }
}

function setPresetValue(value:any, setValue:any, entryType:any) {
  if (!entryType) {
    return;
  }

  if (entryType === 'date' || entryType === 'number') {
    setValue({from: value?.from, to: value?.to });
  } else {
    setValue(value);
  }
}

function FilterDrawer({
  // breakNo,
  // width,
  onSearch,
  onClick, /* Search button click */
  searchStorage,
  setFilterOrderInStorage,
  hidden,
  ...other
}:any) {
  const [isPaneOpen, _setIsPaneOpen] = useState(false);

  const [filterColumnPreset, setFilterColumnPreset] = useState<any>(null);
  //const [filterOrder, _setFilterOrder] = useState<any>(other?.filterOrder);
  const [filterValue, _setFilterValue] = useState<any>(null);

  const multipleSearchRef = useRef<boolean>(false);
  const [isMultipleSearchChecked, setIsMultipleSearchChecked] = useState(false);

  const filterValueRef = useRef<any>(null);

  const noNullOrEmptySearches = other.noNullOrEmptySearches;
  const isNullSearchEnableColumn = nullSearchEnableColumns.some(x => x === filterColumnPreset);
  
  const filterOrderRef = useRef(other?.filterOrder ?? []);

  function setFilterValue(value:any){
    filterValueRef.current = value;
    _setFilterValue(value);
  }

  function setFilterOrder(f:any) {
    filterOrderRef.current = f;
    setFilterOrderInStorage(f);
    //_setFilterOrder(f);
  }

  function setIsPaneOpen(open:any) {
    _setIsPaneOpen(open);
    if (!open) {
      setFilterColumnPreset(null);
      setFilterValue(null);
    }
  }

  const [search, _setSearch] = useState(searchStorage);
  const searchRef = useRef(search);

  function setSearch(data: any) {
    searchRef.current = data;
    _setSearch(searchRef.current);
  }

  let clearSubscription:ISubscriptionDefinition<any>|null = null;
  let presetSubscription:ISubscriptionDefinition<any>|null = null;
  let countSubscription:ISubscriptionDefinition<any>|null = null;
  let dismissSubscription:ISubscriptionDefinition<any>|null = null;

  function subscribeChannels() {
    presetSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.preset',
      callback: ({columnId, value}) => {
        const entryType = getPresetType(columnId, other);
        if (!entryType) {
          // Column is not searchable
          return;
        }

        if (entryType === 'date') {
          const parseResult = dateTextToIso(value);
          if (parseResult.valid) {
            setFilterValue({ from: value, to: null });
          } else {
            setFilterValue({ from: null, to: null });
          }
        } 
        else if (entryType === 'number') {
          setFilterValue({ from: parseFloat(value.replaceAll(',','')), to: null });
        }
        else if (entryType === 'bool') {
          setFilterValue(value);
        } else {
          setFilterValue(_.isEmpty(value.trim()) ? null : value.trim());
        }
        setFilterColumnPreset(columnId);

        setIsPaneOpen(true);
      },
    });
    countSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.count',
      callback: setCount,
    });
    dismissSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.dismiss',
      callback: dismiss,
    });
  }

  function unsubscribeChannels() {
    if (clearSubscription) {
      postal.unsubscribe(clearSubscription);
    }
    if (presetSubscription) {
      postal.unsubscribe(presetSubscription);
    }
    if (countSubscription) {
      postal.unsubscribe(countSubscription);
    }
    if (dismissSubscription) {
      postal.unsubscribe(dismissSubscription);
    }
  }

  function setPageSize(pageSize:any) { 
    setSearch({...searchRef.current, pageSize}); 
  }

  useEffect(() => {
    multipleSearchRef.current = isMultipleSearchChecked;
  }, [isMultipleSearchChecked]);

  useEffect(() => {
    subscribeChannels();

    return () => {
      unsubscribeChannels();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function dismiss() {
    setNullOrEmpty(false);
    setIsMultipleSearchChecked(false);
    setOrderByAscending(false);
    setIsPaneOpen(false);
  }

  function setNullOrEmpty(value: any) {
    if (typeof value === 'string') { //for status, recognized
      value = value.length === 0;
    }
    setSearch({
      ...searchRef.current,
      generalNullOrEmpty: value,
      dateNullOrEmpty: value,
      numberNullOrEmpty: value,
    });
  }

  function setOrderByAscending(value: boolean) {
    setSearch({
      ...searchRef.current,
      orderByAscending : value
    });
  }

  function setCount({search, count}:any) {
    const filterIndex = filterOrderRef.current?.findIndex((x:any) => searchInFilterOrderComparer(x.s, search)); 

    if (filterIndex >= 0) {
      const f:any = [...filterOrderRef.current];
      if (f[filterIndex] && f[filterIndex].count !== count) {
        const newFilterOrder = _.cloneDeep(f[filterIndex]);
        newFilterOrder.count = count;
        f[filterIndex] = newFilterOrder;
        setFilterOrder(f);
        //onSearch(search, false, f);
      }
    }
  }

  //Need when open the Search View and use apply button immediately with a empty('') value
  function isSpecialHeaderWithEmptyValue() {
    if (!search.generalNullOrEmpty)
      return isNullSearchEnableColumn;
    else
      return true;
  }

  function applySearch(applyPageSize: boolean = false) {
    
    const recalcApplyButtonDisable = entryType === 'number' || entryType ==='date' 
    ? (filterValueRef.current?.from === '' || filterValueRef.current?.from === null) && (filterValueRef.current?.to === '' || filterValueRef.current?.to === null) && !(search.dateNullOrEmpty || search.numberNullOrEmpty)
    : ((filterValueRef.current === '' || filterValueRef.current === null) && !search.generalNullOrEmpty) && !isNullSearchEnableColumn;

    
    if (recalcApplyButtonDisable && !applyPageSize) return;

    if (!filterColumnPreset) {
      setIsPaneOpen(false);
      onSearch(search, false, filterOrderRef.current);
      return;
    }

    const newSearch = multipleSearchRef.current 
  ? { ...search } 
  : { ...(other.externalSetSearchInStorage ? other.externalSetSearchInStorage : initialSearch) };

    search.generalNullOrEmpty = isSpecialHeaderWithEmptyValue();
    newSearch.generalNullOrEmpty = search.generalNullOrEmpty;
    newSearch.dateNullOrEmpty = search.dateNullOrEmpty;
    newSearch.numberNullOrEmpty = search.numberNullOrEmpty;
    newSearch.pageSize = search.pageSize;
    if (!newSearch.orderByAscending && (entryType === 'number' || entryType === 'general'))
      newSearch.orderByAscending = true;
    newSearch.isExpressSearch = false;    //Express Search 검색이 아닌 F5 단축키 또는 우클릭 메뉴를 통해 검색할 경우 기존 검색방식으로 동작하도록 하기 위해 추가
    newSearch.listType = search.listType;
 
    const existingEntryIndex = filterOrderRef.current.findIndex((x:any) => x.columnId === filterColumnPreset);
    let filterSlot = existingEntryIndex >= 0 && multipleSearchRef.current ? (filterOrderRef.current[existingEntryIndex] as any|null|undefined)?.slot : null;

    let filterSlotOverride = true;

    if (!filterSlot) {
      filterSlot = getPresetEmptySlot(search, entryType, multipleSearchRef.current);
      filterSlotOverride = false;
    }

    mapPresetValueToSearch(filterColumnPreset, filterValueRef.current, newSearch, filterSlot);

    const searchToApply = {...newSearch};

    let displayValue = filterValueRef.current;
    if(!nullSearchEnableColumns.includes(filterColumnPreset) && displayValue === '') return;
    if (entryType === 'number' || entryType ==='date') {
      displayValue = `${filterValueRef.current?.from || ''} ~ ${filterValueRef.current?.to || ''}`;
    }
    
    const newFilterOrderEntry = {
      columnId: filterColumnPreset,
      slot: filterSlot,
      type: entryType,
      label: filterLabel,
      value: displayValue,
      s: _.cloneDeep(searchToApply),
    };

    if (!filterSlotOverride) {
      if (multipleSearchRef.current) {
        setFilterOrder([newFilterOrderEntry, ...filterOrderRef.current]);
      } else {
        setFilterOrder([newFilterOrderEntry]);
      }
    } else {
      if (multipleSearchRef.current) {
        //const multipleOf:any = [...filterOrderRef.current];
        //multipleOf[existingEntryIndex] = newFilterOrderEntry;
        const multipleOf: any[] = [newFilterOrderEntry, ...filterOrderRef.current];
        multipleOf.splice(existingEntryIndex + 1, 1);
        setFilterOrder(multipleOf);
      } else {
        setFilterOrder([newFilterOrderEntry]);
      }
    }

    setSearch(newSearch);
    setIsPaneOpen(false);

    onSearch(searchToApply, false, filterOrderRef.current);
  }

  /*
  function applyPageSize() {
    applySearch(true);
  }
*/

  function focusEntry() {
    const dataEntryContainer = document.getElementById('ifms-filter-entry-container');
    if (!dataEntryContainer) {
      return;
    }

    if (dataEntryContainer) {
      let focusNode:any = null;

      const tabableElements = dataEntryContainer.querySelectorAll('.ifms-tabable-active');
      if (tabableElements && tabableElements.length > 0) {
        focusNode = tabableElements[0];
      }

      if (focusNode) {
        if (focusNode.focus) {
          focusNode.focus();
        }
        if (focusNode.select) {
          focusNode.select();
        }
      }
    }
    setNullOrEmpty(false);
    setOrderByAscending(false);
    let isMultiple = false;
    if(filterOrderRef.current !== undefined && filterOrderRef.current.length > 0){
      if(filterOrderRef.current.length === 1 && filterOrderRef.current[0].label === filterLabel){
        isMultiple = false;
      }else{
        isMultiple = true;
      }
      if(filterOrderRef.current[0].switchList){
        isMultiple = false;
      }
    }
    setIsMultipleSearchChecked(isMultiple);
  }
  const customRenderers = other.customRenderers || [];

  const entryType = getPresetType(filterColumnPreset, other);
  let filterLabel = getFilterLabel(filterColumnPreset, entryType, other);

  //const showmultipleSearch = !!filterOrder && filterOrder.filter((x:any) => x.columnId !== filterColumnPreset).length > 0;
  const decimals = getDecimals(filterColumnPreset, other);
  const floatOverride = (decimals === 0 ? true : false);

  const applyButtonDisable = entryType === 'number' || entryType ==='date' 
  ? (filterValue?.from === '' || filterValue?.from === null) && (filterValue?.to === '' || filterValue?.to === null) && !(search.dateNullOrEmpty || search.numberNullOrEmpty)
  : ((filterValue === '' || filterValue === null) && !search.generalNullOrEmpty) && !isNullSearchEnableColumn;

  function onEntryValueChange(value:any) {
    setPresetValue(value, setFilterValue, entryType);
  }

  function getDecimals(columnAccessor: any, other: any) {
    const numberFilters = other.numberFilters;
    const formatString: string = numberFilters.find((x:any) => x.accessor === columnAccessor)?.formatString || '';
    let ret = formatString.slice(formatString.lastIndexOf(".")).length;

    if (ret === 0) ret = 2;
    else if (ret > 0) ret--;

    return ret;    
  }

  return (
    <>
      <PrimaryButton size={'regular'} onClick={onClick} name='search-button' style={{display:`${hidden ? 'None': 'inline-block'}`}}>
        Search
      </PrimaryButton>

      <IfmsModal isBlueHeader isOpen={isPaneOpen} title={`${extractScreenTitleBar()} Search - ${filterLabel}`} onCancel={dismiss} width="590px" onShow={focusEntry} draggable isSearch>
        <div className='report-popup'>
          <div>
            {/* {showMultipleSearch && */}
              <div style={{ width: '230px', marginLeft: '20px' }}>
                <LabeledCheckBox name='search-multipleSearch' reverse labelSize="210px" label="Multiple Search" value={isMultipleSearchChecked} onChange={(value) => { setIsMultipleSearchChecked(value); }} />
              </div>
            {/* } */}

            {entryType === 'date' ?
              <div style={{ width: '230px', marginLeft: '20px', marginBottom: '10px' }}>
                <LabeledCheckBox name='search-sort-by-descending' reverse labelSize="210px" label="Sort by Descending" value={!search.orderByAscending} onChange={value => { setOrderByAscending(!value) }} />
              </div>
              :
              <></>
            }

            <FilterContent id="ifms-list-screen-filter">
              <div className="filter-entry-container">
                <div id="ifms-filter-entry-container" className="filter-entry-data">
                  <FilterEntry
                    filterId={filterColumnPreset}
                    filterLabel={filterLabel}
                    entryType={entryType}
                    value={filterValue}
                    onChange={onEntryValueChange}
                    nullOrEmpty={search.generalNullOrEmpty || search.dateNullOrEmpty || search.numberNullOrEmpty}
                    setNullOrEmpty={setNullOrEmpty}
                    customRenderers={customRenderers}
                    applySearch={applySearch}
                    floatOverride={floatOverride}
                    decimals={decimals}
                    noNullOrEmptySearches={noNullOrEmptySearches}
                  />
                </div>
              </div>
            </FilterContent>
          </div>
          
          <div className="filter-info-container">
            <div className="filter-popup-pager">
              <div className="filter-popup-pager-label">
                Max Records
              </div>
              <div className="filter-popup-pager-entry">
                <Number name='ifms-filter-maxRecords' value={search.pageSize} onChange={setPageSize} min={1} max={65000} />
              </div>
              <div className="filter-popup-pager-label">
                (*Max=65,000)
              </div>
            </div>
            <div className="filter-info-summary">
              <FilterSummary filterOrder={filterOrderRef.current} search={search} />
            </div>
          </div>
          
          <div className="clearfix"></div>

          <div className="report-footer" >
            <SecondaryButton name='applyButton' size="regular" focusable={true} onClick={applySearch} disabled={applyButtonDisable} >
              Apply
            </SecondaryButton>&nbsp;&nbsp;
            <SecondaryButton name='cancelButton' size="regular" focusable={true} onClick={dismiss}>
              Cancel
            </SecondaryButton>
          </div>
        </div>
      </IfmsModal>
    </>
  );
}

FilterDrawer.propTypes = {
};

// Don't use memo, it will break useFilterBar hook
export default FilterDrawer;
